import {
  extractError,
  NOT_ENOUGH_FUNDS,
  RPC_ERROR,
  SLIPPAGE,
  USER_DENIED,
  USER_REJECTED,
} from '@/lib/transactionErrors';
import { t } from 'i18next';
import { useState } from 'react';

export function ToastifyDebug(props: any) {
  const [open, setOpen] = useState(false);
  return (
    <div className="Toastify-debug">
      <span
        className="Toastify-debug-button"
        onClick={() => setOpen((old) => !old)}
      >
        {open ? 'Hide error' : 'Show error'}
      </span>
      {open && <div className="Toastify-debug-content">{props.children}</div>}
    </div>
  );
}

export function getErrorMessage(error: any): string {
  const [message, type, errorData] = extractError(error);
  let failMsg: any = '';

  switch (type) {
    case NOT_ENOUGH_FUNDS:
      failMsg = (
        <div>
          {t('There is not enough MATIC in your account on Polygon testnet to send this transaction.')}
        </div>
      );
      break;
    case USER_REJECTED:
      failMsg = t('User Rejected');
      break;
    case USER_DENIED:
      failMsg = t('Transaction was cancelled.');
      break;

    case SLIPPAGE:
      failMsg =
        t('The mark price has changed, consider increasing your Allowed Slippage by clicking on the "..." icon next to your address.');
      break;

    case RPC_ERROR: {
      const originalError =
        errorData?.error?.message || errorData?.message || message;

      failMsg = (
        <div>
          {t('Transaction failed due to RPC error.')}
          <br />
          {t('Please try changing the RPC url in your wallet settings.')}
          <br />
          {originalError && <ToastifyDebug>{t(originalError)}</ToastifyDebug>}
        </div>
      );
      break;
    }

    default:
      failMsg = (
        <div>
          {t('Transaction Failed')}
          <br />
          {message && <ToastifyDebug>{t(message)}</ToastifyDebug>}
        </div>
      );
  }

  return failMsg;
}
